import { clsx } from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export type EmptyStateProps = {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  /** Primary call to action (usually a Button). */
  action?: ReactNode;
  /** Tighter spacing for use inside cards / panels. */
  compact?: boolean;
  className?: string;
};

export function EmptyState({ icon: Icon, title, description, action, compact, className }: EmptyStateProps) {
  return (
    <div className={clsx('flex flex-col items-center justify-center text-center', compact ? 'px-4 py-8' : 'px-6 py-16', className)}>
      {Icon && (
        <div className="mb-3 flex size-10 items-center justify-center rounded-lg border border-slate-200 bg-surface text-slate-400 shadow-xs">
          <Icon size={20} aria-hidden />
        </div>
      )}
      <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-[13px] text-slate-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
